import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/pbatch_run/batch_run_task/');

const state = {
    ...current_module.state,
    columns: [
        // {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'S', value: 'row_statuses', sortable: false, filterable: true, divider: true, width: 30, type: 'status'},
        // {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        // {text: 'Order', value: 'order', sortable: true, filterable: true, divider: true, width: 60},
        {text: 'batch_run__customer_order__notion_id', value: 'batch_run__customer_order__notion_id', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'batch_run__customer_order__title', value: 'batch_run__customer_order__title', sortable: true, filterable: true, divider: true, width: 400},
        // {text: 'batch_run__notion_id', value: 'batch_run__notion_id', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'batch_run__title', value: 'batch_run__title', sortable: true, filterable: true, divider: true, width: 400},
        // {text: 'N', value: 'notion_id', sortable: false, filterable: true, divider: false, width: 10},
        {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true, width: 200},
        {text: 'Status', value: 'status', sortable: true, filterable: true, divider: true, width: 100},
        {text: 'Type', value: 'typ', sortable: true, filterable: true, divider: true, width: 120},
        {text: 'MA', value: 'ma', sortable: true, filterable: true, divider: true, width: 120},
        // {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        // {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        // {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
        {text: 'Target on', value: 'target_on', sortable: true, divider: true, type: 'date', },
        {text: 'Finished on', value: 'finished_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['batch_run__title'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: false,
    },
    filterGroupSingle: [],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        PBatchRunTaskTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}